import React, { FC } from 'react';

import { CtaImageBox } from '@bumble/ui-kit';
import lexemes from 'components/lexemes/page-index';
import useMediaQuery, { MediaQueryWidth } from 'lib/use-media-query';
import router from 'next/router';

export const LandingSubscribeContainer: FC = () => {
    const isMobile = useMediaQuery(MediaQueryWidth['tablet-sm']);
    const isTablet = useMediaQuery(MediaQueryWidth['desktop-md']);
    let imageSrc = '/project-love/assets/subscribe-image-desktop.jpg';
    if (isMobile) {
        imageSrc = '/project-love/assets/subscribe-image-mobile.jpg';
    } else if (isTablet) {
        imageSrc = '/project-love/assets/subscribe-image-tablet.jpg';
    }

    const handleClickSubscribe = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        router.push(`${router.asPath}?subscribe=updates`, undefined, {
            shallow: true,
        });
    };

    return (
        <CtaImageBox
            title={lexemes.lxPageIndexSubscribeTitle}
            description={lexemes.lxPageIndexSubscribeDescription}
            cta={{
                text: lexemes.lxPageIndexSubscribeCta,
                href: '/?subscribe=updates',
                onClick: handleClickSubscribe,
            }}
            image={{
                src: imageSrc,
                alt: lexemes.lxPageIndexSubscribeAlt,
            }}
            isHtml={true}
            imagePosition="start"
        />
    );
};
